import { render, staticRenderFns } from "./RichImageMessage.vue?vue&type=template&id=147c7174&scoped=true&"
import script from "./RichImageMessage.vue?vue&type=script&lang=js&"
export * from "./RichImageMessage.vue?vue&type=script&lang=js&"
import style0 from "./RichImageMessage.vue?vue&type=style&index=0&id=147c7174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c7174",
  null
  
)

export default component.exports